import { baseApi } from './minute'

// キーワード生成用
type GetKeywordsInput = {
  word: string;
  id: string;
}

export type SimilarCompanyIssue = {
  id: number;
  issue_name: string;
  company_score: number;
  company_name: string;
  JSIC: string;
  doc_id: string;
};

export type Keyword = {
  keyword: string;
  similar_company_issues: SimilarCompanyIssue[];
};

export type GetKeywordsResponse = {
  keyword_list: Keyword[];
  search_id: string;
};

export const keywordsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getKeywords: builder.query<GetKeywordsResponse, GetKeywordsInput>({
      query: (getKeywordsInput: GetKeywordsInput) => {
        const {
          word, id
        } = getKeywordsInput;
        return `keywords?word=${encodeURIComponent(word)}&id=${encodeURIComponent(id)}`;
      }
    })
  })
})

// use + endpointsで設定した名前 + QueryでHooksが作られる
export const {
  useLazyGetKeywordsQuery
} = keywordsApi
